/**
 * Register the PWA service worker.
 * Called once at app boot (index.js or App.js).
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Register on load to avoid blocking first paint
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* Service worker registration failed — non-critical */
    });
  });
}
